// Only controlled values and generated correlation IDs may leave the reading flow.
export function safeReadingTags(input = {}) {
  const output = { flow: "reading" };
  const enums = {
    stage: /^(text_he|text_en|questions|question_save|question_status|story_save|question_lookup|client_text|client_questions)$/,
    preset: /^(easy|medium|hard|starter|basic|advanced)$/,
    reason: /^(timeout|network|validation|unsafe_content|internal|persistence|incomplete_response|gemini_\d{3}|http_\d{3}|poll_deadline)$/,
    requestId: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/,
    validation: /^(length|vocalization|vocabulary|structure|quotation|checks|format|other)$/,
  };
  for (const [key, value] of Object.entries(input)) {
    if (enums[key]?.test(String(value))) output[key] = String(value);
    if (["elapsedMs", "attempt", "failures", "status"].includes(key) && /^(0|[1-9][0-9]{0,12})$/.test(String(value))) output[key] = String(value);
  }
  return output;
}
